import { useMemo } from "react";
import { useUserXp } from "./useUserXp";
import { useAchievementsSeen } from "./useAchievementsSeen";
import { Achievement, computeUnlockedAchievements } from "../utils/achievements";
import { ProgressSnapshots } from "../utils/xp";

const NO_SNAPSHOTS: ProgressSnapshots = {};

export function useAchievements() {
    const { status: xpStatus, breakdown, hasProgress, snapshots = NO_SNAPSHOTS } = useUserXp();
    const { seen, markSeen, syncStatus: seenSyncStatus } = useAchievementsSeen();

    // Mission achievements (e.g. "draw all hiragana") are computed from the
    // same snapshots the XP breakdown came from, so feature-threshold and
    // mission achievements share one "progress has resolved" gate below.
    const unlocked = useMemo(
        () => (hasProgress ? computeUnlockedAchievements(breakdown, snapshots) : []),
        [hasProgress, breakdown, snapshots]
    );

    // Wait for BOTH the unlocked set and the seen set to have actually
    // loaded before trusting a diff between them - otherwise a returning
    // user's already-earned achievements would flash as "newly unlocked" on
    // every page load, before their real "seen" record has arrived.
    const isReady = hasProgress && seenSyncStatus !== "loading";
    const newlyUnlocked: Achievement[] = isReady
        ? unlocked.filter((achievement) => seen[achievement.id] !== "seen")
        : [];

    return { status: xpStatus, unlocked, newlyUnlocked, isReady, seen, markSeen };
}
